import React from 'react';

import Container from '@material-ui/core/Container';
import MainAppBar from '../../components/MainAppBar';
import FundsSummary from '../../components/FundsSummary';
import WithdrawPaypal from '../../components/fundingComponents/withdrawPaypal';

import Footer from '../../components/Footer';
import Copyright from '../../components/Copyright';
import checkAuthenticated from '../../utils/checkAuthenticated';


export default function LandingPage() {
  checkAuthenticated();

  let currentFundsAvailable =sessionStorage.getItem('fundsAvailable');
  let currentFundsAtRisk = sessionStorage.getItem('fundsAtRisk')
  
  return (
    < Container maxWidth="sm">
        <MainAppBar></MainAppBar>
        <FundsSummary
          fundsAvailable={currentFundsAvailable}
          fundsAtRisk={currentFundsAtRisk}
        ></FundsSummary>
        <WithdrawPaypal></WithdrawPaypal>
        <Footer></Footer>
        <Copyright></Copyright>
    </Container>
  );
}
